export default __webpack_public_path__ + "24859023f01e5b60daa77ac3a7c1dcbc.png";